export function GetLaunchHyperlink(thelink) {
  var parts = thelink.split("|");
  if (parts.length > 1) thelink = parts[1];

  if (thelink.indexOf("http://") !== 0 && thelink.indexOf("https://") !== 0)
    thelink = "http://" + thelink;

  return thelink;
}
